import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SideBarLayout from '../../../global/layout/SideBarLayout';
import DetailsHeaderTabs from '../locationDetail/DetailsHeaderTabs';
import { handleTabs, showToast } from '../../../utils';

const Communication = () => {

    const params = useParams();
    const { state } = useLocation();
    const locationId = params?.id || '';
    const vaultType = params?.type || '';
    const locationData = state?.location;

    const navigate = useNavigate();
    const [topTab, setTopTab] = useState<any>('communication');

    return (
        <SideBarLayout>
            <div className="right-content-full-screen">
                <div className="ld-page ">
                    <div className="ld-header">
                        <div className="ld-header__left">
                            <h1 className="ld-header__title">{locationData?.name || ''}</h1>
                            <div className="ld-breadcrumb">
                                <button className="ld-breadcrumb__link" onClick={() => navigate(vaultType === 'myvault' ? '/location/myvault' : '/location/vault')}>
                                    {vaultType === 'myvault' ? "My Vault" : 'Location Vault'}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <span className="ld-breadcrumb__current">{locationData?.name || ''}</span>
                            </div>
                        </div>

                        <DetailsHeaderTabs
                            setTopTab={(type: any) => {
                                const route = handleTabs(type);
                                setTopTab(type)
                                if (route) {
                                    navigate(`${route}/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: locationData },
                                    });
                                }
                            }}
                            topTab={topTab}
                        />

                        <div className="ld-header__actions">
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-assign"
                            >
                                Assign Location
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-assign"
                            >
                                Assign to script
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-icon"
                                aria-label="Share"
                            >
                                <img src="/assets/images/upload-share-icon.svg" alt="Share" />
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '18px',
                        color: 'black',
                        textAlign: 'center',
                        width: '100%',
                        padding: '0 16px',
                        boxSizing: 'border-box',
                        fontWeight: 600
                    }}
                >
                    Coming Soon, Please visit <a
                        href="https://www.sixthdegree.io/locations"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.sixthdegree.io/locations
                    </a> for locations already on baord.
                </div>
            </div>

        </SideBarLayout>
    )
}

export default Communication